import { Component, input } from '@angular/core';
import { BooleanPipe } from '@core/pipes/boolean.pipe';
import { ScrollPanel } from 'primeng/scrollpanel';
import { PengeinstitutIndstilling } from '../../pi-indstilling/pengeinstitutindstilling.model';
import { TranslatePipe } from '@core/pipes/translate.pipe';

@Component({
  selector: 'app-pi-detail-begunstigelse',
  imports: [
    BooleanPipe,
    ScrollPanel,
    TranslatePipe
  ],
  templateUrl: './pi-detail-begunstigelse.component.html',
  styleUrl: './pi-detail-begunstigelse.component.css'
})
export class PiDetailBegunstigelseComponent {
  indstillinger = input.required<PengeinstitutIndstilling>();


}
